import React from 'react';

export default function StatCard({ value, label, accent, onClick, hint }) {
	const clickable = typeof onClick === 'function';
	const cardStyle = {
		minWidth: '148px',
		flex: '1 1 148px',
		maxWidth: '220px',
		padding: '14px 16px',
		borderRadius: '10px',
		background: '#fff',
		border: '1px solid #e9ecef',
		borderLeft: `4px solid ${accent}`,
		boxShadow: '0 1px 4px rgba(0, 0, 0, 0.06)',
		cursor: clickable ? 'pointer' : 'default',
		transition: 'box-shadow 0.15s ease, transform 0.15s ease',
		userSelect: 'none',
	};

	const handleActivate = () => {
		if (clickable) onClick();
	};

	const hasValue = value !== undefined && value !== null;

	return (
		<div
			className="autoCreate-stat-card"
			role={clickable ? 'button' : undefined}
			tabIndex={clickable ? 0 : undefined}
			onClick={clickable ? handleActivate : undefined}
			onKeyDown={clickable ? (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					handleActivate();
				}
			} : undefined}
			onMouseEnter={clickable ? (e) => {
				e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.1)';
				e.currentTarget.style.transform = 'translateY(-2px)';
			} : undefined}
			onMouseLeave={clickable ? (e) => {
				e.currentTarget.style.boxShadow = cardStyle.boxShadow;
				e.currentTarget.style.transform = 'translateY(0)';
			} : undefined}
			style={cardStyle}
		>
			{hasValue ? (
				<div style={{
					fontSize: '1.75rem',
					fontWeight: 700,
					lineHeight: 1.1,
					color: accent,
					letterSpacing: '-0.02em',
				}}>
					{value}
				</div>
			) : null}
			<div style={{
				fontSize: hasValue ? '0.8rem' : '0.95rem',
				fontWeight: 600,
				color: '#495057',
				marginTop: hasValue ? '6px' : 0,
				lineHeight: 1.3,
			}}>
				{label}
			</div>
			{clickable && hint ? (
				<div style={{
					fontSize: '0.7rem',
					color: '#868e96',
					marginTop: '8px',
					fontWeight: 500,
				}}>
					{hint}
				</div>
			) : null}
		</div>
	);
}
